export default {
  "toolbarIcon": "_toolbarIcon_uut4q_1"
};import "ni:sha-256;UfypAdwN0xjW5YOuZTYmA-5ceu-xl3wVRaKPORIclFE";